import React from "react";

function Sutrastory(props) {
  return (
    <div
      className="modal fade"
      id="storyTimeModal"
      tabIndex="-1"
      aria-labelledby="storyTimeModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="storyTimeModalLabel">
              Story Time!
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <ul>
              {props.story.map((storypoints, index) => (
                <li key={index} className="my-3" style={{ listStyle: "none" }}>
                  {storypoints}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sutrastory;
